/* ═══ Reveal ═══ */
var obs=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('vis');obs.unobserve(e.target)}})},{threshold:.05,rootMargin:'0px 0px -40px 0px'});
document.querySelectorAll('.rv,.rv-scale').forEach(function(el){obs.observe(el)});
setTimeout(function(){document.querySelectorAll('.rv:not(.vis),.rv-scale:not(.vis)').forEach(function(el){el.classList.add('vis')})},3000);
window.addEventListener('scroll',function(){var b=document.getElementById('scrollTop');if(window.scrollY>500)b.classList.add('show');else b.classList.remove('show')},{passive:true});

/* ═══ Gallery ═══ */
function swapImg(t,s){document.getElementById('mainImg').src=s;document.querySelectorAll('.thumb').forEach(function(x){x.classList.remove('active')});t.classList.add('active')}

/* ═══ Purchase ═══ */

// var purchaseType='sub';
// function setPurchaseType(t){purchaseType=t;document.querySelectorAll('.pt-option').forEach(function(o){o.classList.remove('active')});(t==='sub'?document.querySelector('.pt-option.sub'):document.querySelector('.pt-option.one')).classList.add('active');updatePrices()}
// function setQty(c){document.querySelectorAll('.qty-card').forEach(function(x){x.classList.remove('active')});c.classList.add('active');updatePrices()}

// // var prices={sub:{1:29.71,2:27.16,3:25.46,4:22.91},one:{1:34.95,2:31.95,3:29.95,4:26.95}};
// // var originals={1:34.95,2:31.95,3:29.95,4:26.95};

// function getPrices(){

//   var prices={sub:{},one:{}};
//   var originals={};

//   [1,2,3,4].forEach(function(q){

//     /* base price */

//     originals[q]=basePrice;

//     /* subscription discount 15% */

//     prices.sub[q]=(basePrice*0.85);

//     /* one-time price */

//     prices.one[q]=basePrice;

//   });

//   return {prices,originals}

// }

// var priceData=getPrices();

// var prices=priceData.prices;
// var originals=priceData.originals;

// function updatePrices(){
//   var ac=document.querySelector('.qty-card.active'),qty=parseInt(ac.getAttribute('data-qty')),type=purchaseType;
//   document.querySelectorAll('.qty-card').forEach(function(c){var q=parseInt(c.getAttribute('data-qty'));c.querySelector('.qty-price').textContent='$'+prices[type][q].toFixed(2)});
//   var pu=prices[type][qty],total=(pu*qty).toFixed(2),origTotal=(originals[1]*qty).toFixed(2),saved=(originals[1]*qty-pu*qty).toFixed(2);
//   document.getElementById('priceTotal').textContent='$'+total;
//   if(parseFloat(saved)>0){document.getElementById('priceOrig').textContent='$'+origTotal;document.getElementById('priceOrig').style.display='inline';document.getElementById('priceSave').textContent='SAVE $'+saved;document.getElementById('priceSave').style.display='inline-block'}
//   else{document.getElementById('priceOrig').style.display='none';document.getElementById('priceSave').style.display='none'}
//   if(type==='sub'){document.getElementById('ctaBtn').textContent='Subscribe & Save — $'+total;document.getElementById('priceNote').textContent='Auto-ships every 4 months · 7-day advance email · Skip or cancel anytime'}
//   else{document.getElementById('ctaBtn').textContent='Add to Cart — $'+total;document.getElementById('priceNote').textContent='One-time purchase · Ships within 1–2 business days'}
// }
// updatePrices();







/* ═══ HTC Carousel (3 steps) ═══ */
var htcStep=0,htcTotal=3,htcPlaying=true,htcTimer=null,htcDur=5000,htcStart=null,htcRAF=null;
function goToStep(n){
  htcStep=n;
  document.querySelectorAll('.htc-img-wrap').forEach(function(w){w.classList.remove('active')});var iw=document.querySelector('.htc-img-wrap[data-step="'+n+'"]');if(iw)iw.classList.add('active');
  document.querySelectorAll('.htc-step-content').forEach(function(c){c.classList.remove('active')});var sc=document.querySelector('.htc-step-content[data-step="'+n+'"]');if(sc)sc.classList.add('active');
  document.querySelectorAll('.htc-tl-step').forEach(function(s,i){s.classList.remove('active','done');if(i<n)s.classList.add('done');if(i===n)s.classList.add('active');var pg=s.querySelector('.htc-tl-progress');if(pg)pg.style.strokeDashoffset='113'});
  var fill=document.getElementById('htcFill');if(fill)fill.style.width=(htcTotal>1?(n/(htcTotal-1))*100:0)+'%';
  startRing();if(htcPlaying)startAuto();
}
function startRing(){if(htcRAF)cancelAnimationFrame(htcRAF);htcStart=performance.now();var ad=document.querySelector('.htc-tl-step.active .htc-tl-progress');if(!ad)return;ad.style.strokeDashoffset='113';function tick(now){if(!htcPlaying){htcRAF=requestAnimationFrame(tick);return}var p=Math.min((now-htcStart)/htcDur,1);ad.style.strokeDashoffset=(113*(1-p)).toString();if(p<1)htcRAF=requestAnimationFrame(tick)}htcRAF=requestAnimationFrame(tick)}
function startAuto(){clearTimeout(htcTimer);htcTimer=setTimeout(function(){if(htcPlaying)nextStep()},htcDur)}
function nextStep(){goToStep((htcStep+1)%htcTotal)}
function prevStep(){goToStep((htcStep-1+htcTotal)%htcTotal)}
function togglePlay(){htcPlaying=!htcPlaying;var btn=document.getElementById('htcPlay');if(htcPlaying){btn.textContent='❚❚';btn.classList.add('playing');htcStart=performance.now();startRing();startAuto()}else{btn.textContent='▶';btn.classList.remove('playing');clearTimeout(htcTimer)}}
goToStep(0);

/* ═══ FAQ ═══ */
function toggleFaq(q){var item=q.parentElement,was=item.classList.contains('open');document.querySelectorAll('.faq-item').forEach(function(i){i.classList.remove('open')});if(!was)item.classList.add('open')}

/* ═══ Decline Bars ═══ */
(function(){var targets=[{id:'d1',w:99},{id:'d2',w:90},{id:'d3',w:70},{id:'d4',w:45},{id:'d5',w:20}];var el=document.getElementById('declineVis');if(!el)return;var ob=new IntersectionObserver(function(es){if(es[0].isIntersecting){targets.forEach(function(t,i){setTimeout(function(){var bar=document.getElementById(t.id);if(bar)bar.style.width=t.w+'%'},i*250)});ob.unobserve(el)}},{threshold:.2});ob.observe(el)})();

/* ═══ Inside Cards ═══ */
(function(){['ic1','ic2','ic3'].forEach(function(id,i){var el=document.getElementById(id);if(!el)return;var ob=new IntersectionObserver(function(es){if(es[0].isIntersecting){setTimeout(function(){el.classList.add('on');var fill=el.querySelector('.inside-eff-fill');if(fill)setTimeout(function(){fill.style.width=fill.dataset.w+'%'},150)},i*200);ob.unobserve(el)}},{threshold:.15});ob.observe(el)})})();
